import(/* webpackMode: "eager" */ "C:\\Users\\yjjeon_intsoft\\git\\adduce-landing\\src\\app\\page.tsx");
